// store
import { getStore } from 'shared/store';

// selectors
import { getExperimentsCookie } from 'shared/store/app/selectors';

const useInternalExp = () => {
  const internalCookie = getExperimentsCookie(getStore().getState());
  return internalCookie;

};

export default useInternalExp;
